import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El tablero de pagos, dentro del grupo `_contabilidad`.
 *
 * `rep.facturas_por_vencer`, `rep.tablero_cuentas_por_pagar` y `app.registrar_retencion` exigen las
 * tres `contador` o `administrador`, que es exactamente lo que admite `utilidad.ver`. Y las
 * features 16 y 17 empiezan las cinco veces con «la contadora». Adjudicacion 177.
 */
export const rutaCuentasPorPagar = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/cuentas-por-pagar',
  component: lazyRouteComponent(() => import('./cuentas-por-pagar-pantalla.js'), 'RutaCuentasPorPagar'),
});
